import {EmailInputStyled} from "@/components/UI/Form/Inputs/EmailInput/EmailInput.styled";

const EmailInput = ({inputProps, ...props}) => {
    return (
        <EmailInputStyled {...props} inputProps={{...inputProps, type: 'email'}}/>
    );
};

export default EmailInput;